import {mapMutations} from "vuex";
import {dynamicHead} from '@/mixins/dynamic-head.js'

export default {
    name: "seo-text",
    mixins: [dynamicHead],
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    components: {},
    data() {
        return {
            params: {
                title: '',
                description: '',
            }
        }
    },
    created() {
        if (this.item) {
            this.setParams()
            this.setMeta()
        }
    },
    computed: {
        footerDescription() {
            if (!this.item) {
                return ''
            }
            return (
                this.item.footerDescription
                || this.item.footer_description
                || this.item.content
                || ''
            )
        },
        footerTitle() {
            if (!this.item) {
                return ''
            }
            return (
                this.item.footerTitle
                || this.item.footer_title
                || this.item.title
                || ''
            )
        },
        hasFooterContent() {
            return !!String(this.footerDescription).trim()
        },
    },
    methods: {
        ...mapMutations({}),
        setParams() {
            this.params.title = this.footerTitle;
            this.params.description = this.footerDescription;
        }

    }
}
